import React from 'react';

import Box from '@material-ui/core/Box'
import {setImgFromCache } from '../../utils/cacheUtils';

const MiniIklan=React.memo(props=>{
  const {
    liveAds,
    light,
    onClick,
    showPrice=true,
  }=props

  const imgRef=React.useRef()

  const [price,setPrice]=React.useState("")
  React.useEffect(()=>{
    let p=liveAds?.purchasePrice||0
    if( p >= 1000000000){
      setPrice("Rp " + ((liveAds?.purchasePrice||0)/1000000000).toLocaleString("ID-id")+" M")
    }else if(p>=1000000){
      setPrice("Rp " + ((liveAds?.purchasePrice||0)/1000000).toLocaleString("ID-id")+" Jt")
    }else if(p>=1000){
      setPrice("Rp " + ((liveAds?.purchasePrice||0)/1000).toLocaleString("ID-id")+" K")
    }else{
      setPrice("Rp " + (liveAds?.purchasePrice||0).toLocaleString("ID-id"))
    }


    let imageURL=liveAds?.thumb_photoURL||liveAds?.photoURL||""
    if(imageURL.startsWith("/")){
      //load cache
      setImgFromCache(imageURL,imgRef,()=>{

      },(e)=>{
        console.log("error",e)
      })
    }else if(imageURL.startsWith("http")){
      //load from URL
      if(!!imgRef.current) imgRef.current.src=imageURL
    }else{
      if(!!imgRef.current) imgRef.current.src="/static/no-image.png"
    }


  },[liveAds])

  const handleClick=React.useCallback(()=>{
    if(!!onClick)onClick(liveAds)
  },[onClick,liveAds])

  return (
    <Box
      component="span"
      style={{
        display:"inline-block",
        width:"80px",
        height:"80px",
        overflow:"hidden",
        border:light?"1px solid white":"1px solid black",
        margin:"auto 2px",
        position:"relative",
        cursor:"pointer"
      }}
      onClick={handleClick}
      tabIndex={0}
      onKeyDown={handleClick}
    >
      {/* <a href={liveAds.photoURL} target="_blank" rel="noopener noreferrer"> */}
        <img
          style={{
            height:"80px",
            width:"80px",
            objectFit:"contain",
          }}
          ref={imgRef}
          src="#"
          alt="iklan"
        />
      
      {showPrice&&<Box
        style={{
          position:"absolute",
          bottom:"0",
          left:"0",
          padding:"0px 2px",
          backgroundColor:light?"rgba(255,255,255,0.7)":"rgba(0,0,0,0.5)",
          color:light?"black":"white",
          fontSize:"12px",
          fontWeight:"bold",
        }}
      >
        {price}
      </Box>}
    </Box>
  )
})

export default MiniIklan